import { render, staticRenderFns } from "./ModelHomePopup.vue?vue&type=template&id=4ba4e380&"
import script from "./ModelHomePopup.vue?vue&type=script&lang=js&"
export * from "./ModelHomePopup.vue?vue&type=script&lang=js&"
import style0 from "./ModelHomePopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports